import { createContext, useContext } from "react";

export const AuthContext = createContext(null);

export function useAuth() {
  const contextValue = useContext(AuthContext);
  if (!contextValue) {
    throw new Error("useAuth must be used inside an AuthProvider");
  }
  return contextValue;
}
